import {AppHelper} from "../appHelper"
import {MouseButton} from "../core/components/menu";
import {AppBaseProps, CommonApp, Context, Entity, Metadata} from "../core/components/commonApp";
import {Grid} from "../core/components/grid";
import {Helper} from "../core/util/helper";
import {Config} from "../core/config/config";
import {HTTPService, JsonResultClass} from "../core/util/httpManager";
import {General} from "../../siteManagement/general";
import {SheetEventType} from "../../siteManagement/sheet";
import {RSplitter, RSplitterDirection} from "../core/components/rSplitter";
import MonitorTreeApp from "../monitor/monitorTree";
import {StringKeyDictionary} from "../commonInterfaces";
import React from "react"
export default class CockpitApp extends React.Component<CockpitAppProps, CockpitAppState> {
    private leftChildStyle: React.CSSProperties = {
        //border: "1px solid #ddd",
        // minHeight: 200,
        // marginBottom: 5
    }
    private ticketsMonitorDiv: HTMLElement = null;
    private lastMouseButtonClicked: MouseButton = MouseButton.Unknown;
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    addressView: Array<{ label: string, model: string, type?: string, bold?: boolean }> = null;
    contactsGridOptions: kendo.ui.GridOptions = null;
    machinesGridOptions: GridColumns = null;
    ticketsGridOptions: kendo.ui.GridOptions = null;
    projectsGridOptions: kendo.ui.GridOptions = null;
    assignmentsGridOptions: kendo.ui.GridOptions = null;
    serviceReportsGridOptions: kendo.ui.GridOptions = null;
    private _ticketsGrid: Grid;


    constructor(props: CockpitAppProps) {
        super(props);

        this.state = {
            address: props.address,
            machine: props.machine,
            contact: props.contact,
            maschNrs: props.machine ? [props.machine] : [],
            addressViewData: {},
            contacts: [],
            machines: [],
            tickets: []
        };

        this.common.enableHooks = true;

        this.common.init(this);

        $(window).on("tabStripTabSelected", (_e, data) => {
            if (data.firstLoad) {
                const t = setInterval(() => {
                    if (Helper.hasValue(window["monitorHolder"])) {
                        clearInterval(t);
                        window["monitorHolder"].setInitialTreeData("maschnr", this.state.maschNrs[0]);
                    }
                }, 100);
            }
        });
    }

    componentDidUpdate(prevProps: Readonly<CockpitAppProps>, prevState: Readonly<CockpitAppState>, snapshot?: any) {
        if (prevState.address !== this.state.address) {
            General.Functions.HistoryState.replaceState("Cockpit/IndexAddress?id=" + encodeURIComponent(this.state.address));
            this.getCockpitData().then(() => { });
            this.common.updateEntity(this.getEntity());
            this.common.updateSheetTitle();
        }
        if (prevState.maschNrs !== this.state.maschNrs) {
            this.getTicketGridData().then(() => { });
        }
    }

    private renderLeftChild = (content, label) => {
        let style = $.extend({}, this.leftChildStyle);

        return (
            <div style={style} className="flex-container cockpitView">
                <div className="cockpit__label">{label}</div>
                <div className="flex-container__item">{content}</div>
            </div>
        );
    }


    private renderAddressView = () => {
        let arr = [];

        this.addressView.forEach((item) => {
            let content: any;

            const val = this.state.addressViewData[item.model];

            if (item.type === "url") {
                content = <a style={{ color: "#173D78" }} href={Config.baseUrl + "Address/Edit?id=" + encodeURIComponent(val)}>{val}</a>;
            } else if (item.type === "textarea") {
                content = <span style={{ whiteSpace: "pre-line" }}>{val}</span>;
            } else if (item.type === "visibleIfAvailable") {
                if (val <= 0)
                    return;
                content = <span>{item.label}</span>
            } else {
                content = <span>{val}</span>;
            }
            arr.push(<tr key={kendo.guid()}><td style={{ padding: "3px", fontWeight: item.bold === true ? "bold" : null, lineHeight: "1.2em" }}>{content}</td></tr>)
            if (item.model == "IndividualData.AdrNr") {
                for (let i = 0; i < this.state.addressViewData.IndividualData[0].length; i++) {
                    let k = kendo.guid();
                    const text = this.state.addressViewData.IndividualData[0][i];
                    let contentIndiv = <span>{text}</span>;

                    arr.push(<tr key={k}><td style={{ padding: "3px" }}>{contentIndiv}</td></tr>);
                }
            }
        });

        return (
            <div style={{ height: "100%", overflowY: "auto", padding: "10px", fontSize: "15px" }}>
                <table>
                    <tbody>
                        {arr}
                    </tbody>
                </table>
            </div>
        );
    }

    private renderContactsGrid = () => {
        return (
            <Grid data={this.state.contacts} selectFilter={Helper.hasValue(this.state.contact) ? this.state.contact.toString() : null} options={this.contactsGridOptions} id="cockpitContacts"
                rowColorRules={[{
                    column: "Inaktiv", value: "1", backgroundColor: "#cccccc", color: "#000000"
                }]}
                onSelectionChanged={(item) => {
                    const newContact = Helper.hasValue(item) ? item.Pos : null;
                    this.setState({ contact: newContact });
                }}
                onDataBound={(e) => {
                    let data = e.sender.dataSource.view();
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].Inaktiv == 1) {
                            let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                            let cell = $("td", row);
                            cell.css("background-color", "#ef9a9a");
                            cell.css("color", "#000000");
                        }
                    }
                }}
            />
        );
    }

    private renderMachinesGrid = () => {
        return (
            <Grid data={this.state.machines} selectFilter={this.state.machine} options={this.machinesGridOptions} id="cockpitMachines"
                rowColorRules={[{
                    column: "Status", value: "1", backgroundColor: "#cccccc", color: "#000000"
                }]}
                onSelectionChanged={(item) => {
                    let maschNrs = [];
                    if (Helper.hasValue(item)) {
                        if (Array.isArray(item)) {
                            maschNrs = item.map((m) => {
                                return m.MaschNr;
                            });
                        } else {
                            maschNrs = [item.MaschNr];
                        }
                    }
                    this.setState({ maschNrs: maschNrs })

                    this.refreshMonitor();
                }}
                onDataBound={(e) => {
                    let data = e.sender.dataSource.view();
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].Status == 1) {
                            let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                            let cell = $("td", row);
                            cell.css("background-color", "#ef9a9a");
                            cell.css("color", "#000000");
                        }
                    }
                }} />
        );
    }

    public createTextView = () => {
        const props = this.getCommonProps();

        return <TicketsTextViewApp {...props} />;
    }

    private getTicketGridData = async () => {
        let result = await HTTPService.post("Cockpit/GetProceduresByMaschNrs", { maschNrsText: this.state.maschNrs.join(","), adrNr: this.state.address })
        if (Helper.hasValue(result.Data))
            this.setState({ tickets: result.Data })
        else
            this.setState({ tickets: [] });
    }

    private refreshMonitor = () => {
        if (typeof window["monitorHolder"] !== "undefined") {
            window["monitorHolder"].setInitialTreeData("maschnr", this.state.maschNrs.length > 0 ? this.state.maschNrs[0] : null);
        }
    }

    private handleMenuSelect = (action, button: MouseButton) => {
        this.lastMouseButtonClicked = button || MouseButton.Unknown;
        if (button === MouseButton.Left || button === MouseButton.Middle) {
            this.common.handleMenuSelect(action);
        }
    }


    createGrid = () => {
        return <Grid data={this.state.tickets} options={this.ticketsGridOptions} onSelectionChanged={this.onTicketSelected} id="cockpitTickets" ref={(g) => {this._ticketsGrid = g;} } />;
    }

    exportTicketsToExcel = () => {
        this._ticketsGrid.exportExcel();
    }
    
    private onTicketSelected = (dataItem: any) => {
        let ticketId = dataItem != null ? dataItem.ProblemNr : null;
        if (this.props.entity.selectedTicketId != ticketId) {
            let copiedEntity: any = JSON.parse(JSON.stringify(this.props.entity));
            copiedEntity.selectedTicketId = ticketId;

            Helper.updateEntity(this.props.entity, copiedEntity);
            this.setState({});
        }
    }

    createProjectsGrid = () => {
        const props = { ...this.getCommonProps(), projectsGridOptions: this.projectsGridOptions };

        return <CockpitProjectsApp {...props} />;
    }

    createAssignmentsGrid = () => {
        const props = { ...this.getCommonProps(), assignmentsGridOptions: this.assignmentsGridOptions };

        return <CockpitAssignmentsApp {...props} />;
    }

    createServiceReportsGrid = () => {
        const props = { ...this.getCommonProps(), serviceReportsGridOptions: this.serviceReportsGridOptions };

        return <CockpitServiceReportsApp {...props} />;
    }

    // noinspection JSUnusedGlobalSymbols
    createMonitorTree = () => {
        let maschNr = this.state.maschNrs.length == 1 ? this.state.maschNrs[0] : null;
        return <MonitorTreeApp adrNr={this.state.address} maschNr={maschNr} common={this.common} treeFile={"pms_tree_files"}/>
    }

    createLeftSide = () => {
        let oldDiv = <div style={{ minWidth: 200, height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}></div>;
        return (
            <RSplitter direction={RSplitterDirection.Vertical} rememberPercentage={true} initialPercentage={20} id={'cockpitLeftSideAddress'}>
                {this.renderLeftChild(this.renderAddressView(), this.translations["Adresse.Adresse"])}
                <RSplitter direction={RSplitterDirection.Vertical} rememberPercentage={true} initialPercentage={40} id={'cockpitLeftSideContacts'}>
                    {this.renderLeftChild(this.renderContactsGrid(), this.translations["Ansprechpartner.Ansprechpartner"])}
                    {this.renderLeftChild(this.renderMachinesGrid(), this.translations["Navigation.Maschinen"])}
                </RSplitter>
            </RSplitter>
        );
    }

    onTabChange = (tabKey: string) => {
        if (this.props.entity.selectedTabKey != tabKey) {
            let copiedEntity: any = JSON.parse(JSON.stringify(this.props.entity));
            copiedEntity.selectedTabKey = tabKey;

            Helper.updateEntity(this.props.entity, copiedEntity);
            this.setState({});
        }
    }

    openAddress = () => {
        let url = `DynamicSearch/Window/Address/?multi=false`;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, (ev) => {
            this.setState({ address: ev, machine: null, contact: null })
        })
    }

    openMachine = () => {
        const adrNr = encodeURIComponent(this.props.entity.AdrNr);
        let searchType = "Machine";
        let fillAdrNr = false;
        let disableAdrNr = false;

        let url = `DynamicSearch/Window/${searchType}/?multi=false&fullObject=true`;
        if (fillAdrNr)
            url += `&adrnr=${adrNr}`;
        if (disableAdrNr)
            url += `&disabled=adrnr`;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });

        sheet.bind(SheetEventType.RowClicked, (ev) => {
            this.setState({ address: ev.adrnr, machine: ev.maschnr, contact: null })
        })
    }

    openContact = () => {
        let url = `DynamicSearch/Window/Contact/?multi=false&fullObject=true`;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });

        sheet.bind(SheetEventType.RowClicked, (ev) => {
            console.log(ev);
            this.setState({ address: ev.adrnr, contact: ev.pos, machine: null })
            console.log("Jaya Radhe!");
        })
    }

    // noinspection JSUnusedGlobalSymbols
    newTicket = () => {
        const url = `${Config.baseUrl}Procedure/New?id=${encodeURIComponent(this.state.address)}`
            + (this.state.maschNrs.length > 0 ? "&id2=" + encodeURIComponent(this.state.maschNrs[0]) : "")
            + (Helper.hasValue(this.state.contact) ? "&id3=" + this.state.contact : "");
        if (this.lastMouseButtonClicked === MouseButton.Middle) {
            Helper.openInNewBrowserTab(url);
        } else {
            window.location.href = url;
        }
    }

    private getCockpitData = async () => {
        this.getTicketGridData().then(() => { });

        let result = await HTTPService.get(`Cockpit/GetData?adrNr=${encodeURIComponent(this.state.address)}`);

        this.setState(
            {
                addressViewData: result.address,
                contacts: result.contacts,
                machines: result.machines
            });
    };

    componentDidMount() {
        this.getCockpitData().then(() => { });
    }

    getEntity = (): CockpitEntity => {
        return {
            ...this.props.entity,
            AdrNr: this.state.address,
            Machines: this.state.maschNrs,
            Contact: this.state.contact
        };
    }

    getCommonProps = (): any => {

        let selectedMachine = '';
        if (this.state.maschNrs.length > 0) {
            let machine = this.state.machines.find(m => m.MaschNr == this.state.maschNrs[0]);
            let machineText = this.state.maschNrs[0];
            if (machine)
                machineText += " " + machine?.MaschBezeichnung;
            let titleAddon = Helper.getTranslation("Maschine.MachineSelected").replace("{x}", `"${machineText}"`);
            if (this.state.maschNrs.length > 1)
                titleAddon = Helper.getTranslation("Maschine.XMachinesSelected").replace("{x}", this.state.maschNrs.length.toString());
            selectedMachine = ' (' + titleAddon + ')';
        }

        let commonProps = this.common.getHandlersForProps();

        return {
            ...this.props,
            ...commonProps,
            sheetTitle: commonProps.sheetTitle + selectedMachine,
            handleMenuSelect: this.handleMenuSelect,
            dc4Splitter: { direction: RSplitterDirection.Horizontal, initialPercentage: 30, rememberPercentage: true },

            entity: this.getEntity(),
            addressViewData: this.state.addressViewData,
            machines: this.state.machines,
            contacts: this.state.contacts,
            context: { ...this.props.context, keyVal1: this.state.address }
        };
    }

    render() {
        return <CommonApp {...this.getCommonProps()} 
                          dc4ComponentFunc={this.createLeftSide} 
                          onTabChange={this.onTabChange} 
                          formContainerClass="flex-container--row" 
                          horizontalTabStrip={false} />;
    }

};

interface CockpitAppState {
    address: string
    machine: string
    contact: number
    maschNrs: string[]
    addressViewData: { IndividualData?: any }
    contacts: []
    machines: { MaschNr: string; IndividualData: {}; MaschBezeichnung: string }[]
    tickets: Array<any>
}

interface GridFieldProps {
    field: {
        searchSettings: {
            searchType: string;
            displayPattern: string;
            fillAdrNr: boolean;
            disableAdrNr: boolean;
            forceAdrNrEqual: boolean;
        };
    };
    disabled: boolean;
}

interface GridColumns {
    columns: Array<any>;
}

interface CockpitServiceReportsProps extends AppBaseProps {
    entity: CockpitEntity
    serviceReportsGridOptions: any
}

interface CockpitServiceReportsState {
    Machines: any[]
    ServiceReports: any[]
}

class CockpitServiceReportsApp extends React.Component<CockpitServiceReportsProps, CockpitServiceReportsState>
{
    constructor(props: CockpitServiceReportsProps) {
        super(props);
        this.state = {
            ServiceReports: [],
            Machines: []
        };
    }

    componentDidMount() {
        this.updateData();
    }

    private updateData() {
        let machines = this.props.entity.Machines;
        HTTPService.post("Cockpit/GetServiceReports", {
            maschNrsText: machines ? machines.join(",") : "",
            adrNr: this.props.entity.AdrNr
        })
            .then((result) => {
                if (Helper.hasValue(result.Data))
                    this.setState({ ServiceReports: result.Data, Machines: machines })
                else
                    this.setState({ ServiceReports: [], Machines: machines });
            });
    }

    componentDidUpdate(prevProps: CockpitServiceReportsProps, prevState: CockpitServiceReportsState) {
        if (prevProps.entity.AdrNr != this.props.entity.AdrNr
            || this.props.entity.Machines != this.state.Machines) {
            this.updateData();
        }
    }

    render() {
        return <Grid data={this.state.ServiceReports} options={this.props.serviceReportsGridOptions} id="cockpitServiceReports" />;
    }
}

interface CockpitAssignmentsProps extends AppBaseProps {
    entity: CockpitEntity
    assignmentsGridOptions: any
}

interface CockpitAssignmentsState {
    Machines: any[]
    Assignments: any[]
}

class CockpitAssignmentsApp extends React.Component<CockpitAssignmentsProps, CockpitAssignmentsState>
{
    constructor(props: CockpitAssignmentsProps) {
        super(props);
        this.state = {
            Assignments: [],
            Machines: []
        };
    }

    componentDidMount() {
        this.updateData();
    }

    private updateData() {
        let machines = this.props.entity.Machines;
        HTTPService.post("Cockpit/GetAssignments", {
            maschNrsText: machines ? machines.join(",") : "",
            adrNr: this.props.entity.AdrNr
        })
            .then((result) => {
                if (Helper.hasValue(result.Data))
                    this.setState({ Assignments: result.Data, Machines: machines })
                else
                    this.setState({ Assignments: [], Machines: machines });
            });
    }

    componentDidUpdate(prevProps: CockpitAssignmentsProps, prevState: CockpitAssignmentsState) {
        if (prevProps.entity.AdrNr != this.props.entity.AdrNr
            || this.props.entity.Machines != this.state.Machines) {
            this.updateData();
        }
    }

    render() {
        return <Grid data={this.state.Assignments} options={this.props.assignmentsGridOptions} id="cockpitAssignments" />;
    }
}

interface CockpitProjectsProps extends AppBaseProps {
    entity: CockpitEntity
    projectsGridOptions: any
}

interface CockpitProjectsState {
    Machines: any[]
    Projects: any[]
}

class CockpitProjectsApp extends React.Component<CockpitProjectsProps, CockpitProjectsState>
{
    constructor(props: CockpitProjectsProps) {
        super(props);
        this.state = {
            Projects: [],
            Machines: []
        };
    }

    componentDidMount() {
        this.updateData();
    }

    private updateData() {
        let machines = this.props.entity.Machines;
        HTTPService.post("Cockpit/GetProjects", {
            maschNrsText: machines ? machines.join(",") : "",
            adrNr: this.props.entity.AdrNr
        })
            .then((result) => {
                if (Helper.hasValue(result.Data))
                    this.setState({ Projects: result.Data, Machines: machines })
                else
                    this.setState({ Projects: [], Machines: machines });
            });
    }

    componentDidUpdate(prevProps: CockpitProjectsProps, prevState: CockpitProjectsState) {
        if (prevProps.entity.AdrNr != this.props.entity.AdrNr
            || this.props.entity.Machines != this.state.Machines) {
            this.updateData();
        }
    }

    render() {
        return <Grid data={this.state.Projects} options={this.props.projectsGridOptions} id="cockpitProjects" />;
    }
}

class TicketsTextViewApp extends React.Component<TicketsTextViewProps, TicketsTextViewState>
{
    _levelLabel: string;
    _inputRef: HTMLInputElement = null;

    private readonly _bubbleStyle: React.CSSProperties = {
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingRight: "3px",
        paddingLeft: "3px",
        borderRadius: "0px",
        boxShadow: "0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12)",
        backgroundColor: "#E0E0E0",
        lineHeight: "1.5em",
        marginTop: "5px"
    };
    private readonly _userStyle: React.CSSProperties = {
        backgroundColor: "#546E7A",
        color: "white"
    };


    constructor(props: TicketsTextViewProps) {
        super(props);
        this._levelLabel = Helper.getTranslation("Field.Vorgang.stufe");
        this.state = { Tickets: [], Machines: [], SearchString: null };
    }

    componentDidMount() {
        this.updateData();
    }

    private updateData() {
        let machines = this.props.entity.Machines;
        HTTPService.post<JsonResultClass<TicketWithComments[]>>("Cockpit/GetProceduresWithCommentsByMaschNrs", {
            maschNrsText: machines ? machines.join(",") : "",
            adrNr: this.props.entity.AdrNr
        })
            .then((result) => {
                if (result.Code !== 0)
                    return;
                this.cleanUpInput();
                this.setState({ Tickets: result.Data, Machines: machines, SearchString: null })
            });
    }

    private cleanUpInput() {
        if (this._inputRef)
            this._inputRef.value = "";
    }
    componentDidUpdate(prevProps: TicketsTextViewProps, prevState: TicketsTextViewState) {
        if (prevProps.entity.AdrNr != this.props.entity.AdrNr
            || this.props.entity.Machines != this.state.Machines) {
            this.updateData();
        }
    }

    private _commentTypeText = (ct: Number) => {

        switch (ct) {
            case 2:
                return Helper.getTranslation("Field.Vorgang.anmerkung");
            case 3:
                return Helper.getTranslation("WebSMS.Procedure.RectificationText");
            default:
                return Helper.getTranslation("Regionen.Vorgang.Beschreibung");
        }
    }



    private highlight = (text = '') => {
        const highlight = this.state.SearchString;

        if (!Helper.hasValue(highlight) || !highlight.trim()) {
            return text;
        }
        const regex = new RegExp(`(${Helper.escapeRegExp(highlight)})`, 'gi')
        const parts = text.split(regex)
        return (
            <span>
                {parts.filter(part => part).map((part) => (
                    regex.test(part) ? <mark key={kendo.guid()}>{part}</mark> : <span key={kendo.guid()}>{part}</span>
                ))}
            </span>
        )
    }
    private urlify = (text: string, isUser: boolean) => {
        const fontColor = isUser ? "#e0e0e0" : "#767676";
        const urlRegex = /(https?:\/\/\S+)/g;

        return text.split(urlRegex).map((s) => {
            if (s.match(urlRegex)) {
                return <a key={kendo.guid()} href={s} style={{ color: fontColor }} target="_blank" >{this.highlight(s)}</a>
            }

            return <React.Fragment key={kendo.guid()}>{this.highlight(s)}</React.Fragment>
        });
    }

    private _handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ SearchString: e.currentTarget.value })
    }

    render() {

        let tickets = this.state.Tickets.map((e) => {

            const statusExtern = Helper.hasValue(e.StatusExtern) ? `${e.StatusExtern}, `: '';
            let terminDate = kendo.parseDate(e.Termin1);
            terminDate.setHours(0, 0, 0, 0);
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let terminOk = (terminDate < today) ? "overdue"
                : (terminDate > today) ? "notdue": "due";
            const ticketComment = `: ${e.Kommentar} - `;
            let statusText = ` (${statusExtern}${e.StatusInternBezeichnung})`;
            const ticketNr = `#${e.ProblemNr}/${e.Stufe}`;

            let found = false;
            if (Helper.hasValue(this.state.SearchString)) {
                if (Helper.hasValue(ticketComment) &&
                    ticketComment.match(new RegExp(Helper.escapeRegExp(this.state.SearchString), "i")) != null)
                    found = true;
                if (!found && Helper.hasValue(ticketNr) &&
                    ticketNr.match(new RegExp(Helper.escapeRegExp(this.state.SearchString), "i")) != null)
                    found = true;
            }
            else
                found = true;


            let comments = e.Comments.map((c, i) => {
                const thisUser = Config.user.userName === c.Name;

                let extendet = "";

                let type_text = this._commentTypeText(c.Type);

                if (Config.user.isExternal && (c.Type === 2)) {
                    return null;
                }

                extendet = `${type_text}`;

                const classNameText = "legend_label_type" + c.Type.toString();
                const className = thisUser ? "legend_self_type" + c.Type.toString() : "legend_other_type" + c.Type.toString();

                if (!found) {
                    if (c.Text.match(new RegExp(Helper.escapeRegExp(this.state.SearchString), "i")) != null)
                        found = true;
                }

                return (
                    <div key={"c_" + c.ProblemNr + "_" + i}
                        className={"ticketComment"}
                        style={{ marginBottom: "15px", maxWidth: "90%", alignSelf: thisUser ? "flex-end" : "flex-start" }}>
                        <label style={{ textAlign: thisUser ? "right" : null, fontSize: "12px" }}>
                            {c.FullName} - {this._levelLabel} {c.Level} - {kendo.toString(kendo.parseDate(c.AddDate), "G")} {extendet == "" ? null : " - "} {extendet == "" ? null : <span className={classNameText}>{extendet}</span>}
                        </label>
                        <div style={{ ...this._bubbleStyle, ...(thisUser ? this._userStyle : null) }}>
                            <div className={className}>
                                {
                                    c.Text.split("\n").map(
                                        (t, n) =>
                                        (<p key={"p_" + c.ProblemNr + "_" + i + "_" + n}
                                            id={c.Id} style={{ wordBreak: "break-word", whiteSpace: "pre-wrap", padding: "0 3px" }}>
                                            {this.urlify(t, thisUser)}
                                        </p>)
                                    )
                                }
                            </div>
                        </div>
                    </div>);
            });

            if (!found)
                return null;

            let ticketTexteClass = "ticketTexte";
            if (e.StatusIntern == "9999")
                ticketTexteClass += " closedTicket";
            
            return (
                <div key={"t_" + e.ProblemNr + "." + e.Stufe} className={ticketTexteClass} style={{ display: "flex", flexDirection: "column" }}>
                    <label className={"ticketHeader"}>{Helper.getTranslation("Vorgang.Ticket")} <a href={Config.baseUrl + "Procedure/Edit?id=" + e.ProblemNr}>{this.highlight(ticketNr)}</a>
                        {this.highlight(ticketComment)}<span className={terminOk}>{this.highlight(kendo.toString(terminDate, "d"))}</span>{this.highlight(statusText)}</label>
                    {comments}
                </div>);
        })

        const searchPanel = (
            <div className="cockpit__quicksearchpanel">
                <span className="k-textbox k-input k-input-md k-rounded-md k-input-solid" style={{ width: "240px" }}>
                    <span className="k-input-prefix">
                        <span className="k-icon k-i-search"></span>
                    </span>
                    <input ref={r => this._inputRef = r} placeholder={Helper.getTranslation("Suche.QuickSearch")} id="icon-left" type="search" className="k-input-inner" style={{ paddingLeft: "0px" }} onChange={this._handleSearchChange} />
                </span>
            </div>);

        return (
            <div style={{ paddingLeft: "5px", display: "flex", flexDirection: "column", overflow: "auto", height: "100%" }}>
                <div className={"cockpit__label"}>{Helper.getTranslation("Auftrag.TicketTexts")}</div>
                {searchPanel}
                <div style={{ flex: 1, overflow: "auto", height: "100%" }}>{tickets}</div>
            </div>);
    }
}

interface TicketsTextViewState {
    Tickets: Array<TicketWithComments>;
    Machines: Array<string>
    SearchString: string;
}

interface TicketsTextViewProps extends AppBaseProps {
    entity: CockpitEntity;
}

interface TicketComment {
    AddDate: string;
    FullName: string;
    Id: string;
    Level: number;
    Name: string;
    ProblemNr: number;
    Text: string;
    Type: number;
    UTCAddDate: string;
}

interface TicketWithComments {
    AdrName: string;
    AdrNr: string;
    Ansprechpartner: string;
    Comments: Array<TicketComment>;
    CreateDate: string;
    Hotliner: string;
    Kommentar: string;
    MaschNr: string;
    Maschinenbezeichnung: string;
    Name: string;
    ProblemNr: number;
    StatusExtern: string;
    StatusIntern: string;
    StatusInternBezeichnung: string;
    Stufe: number;
    Termin1: string;
    Typ: string;
    Zeit: string;
}

export interface CockpitAppProps extends AppBaseProps {
    context: Context;
    entity: CockpitStarterEntity;
    isWindow: boolean;
    metadata: Metadata;
    address?: string;
    machine?: string;
    contact?: number;
}
export interface CockpitStarterEntity extends Entity {
    AdrNr: string;
    selectedTicketId: number;
    selectedTabKey: string;
}

interface CockpitEntity extends Entity {
    AdrNr: string;
    Machines: Array<any>;
    Contact: number;
}